export default function Footer() {
  return (
    <footer className="text-center py-4 bg-blue-500 text-white">
      &copy; Om Dubey
    </footer>
  );
}
